/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  var cartCount = 0;
  var currentVariant;
  document.addEventListener('theme:variant:change', (event) => {  
    let variant = event.detail.variant;
    if (!variant) return;
    currentVariant = variant.id;
    if (document.body.classList.contains('template-product')) {
      if(document.querySelector('#stickyATC')) {
        document.querySelector('#stickyATC input[name="id"]').value = variant.id;
        document.querySelector('#stickyATC span[data-product-price]').innerText = document.querySelector('.product-single__details .product__form .btn--submit span[data-product-price]').innerText;
        document.querySelector('#stickyATC span[data-add-to-cart-text]').innerText = document.querySelector('.product-single__details .product__form .btn--submit span[data-add-to-cart-text]').innerText;
      }
      document.querySelectorAll('.sky-product-service').forEach(item=>{
        item.innerText = variant.option1;
      });
      document.querySelectorAll('.sky-product-session').forEach(item=>{
        item.innerText = variant.option2;
      });      
      document.querySelectorAll('.sky-product-session3').forEach(item=>{
        item.innerText = variant.option3;
      });      
      document.querySelectorAll('[data-view-cart]')?.forEach(selector => {
        selector.setAttribute('data-add-to-cart', '');
        selector.setAttribute('type', 'submit');
        if(selector.querySelector('[data-add-to-cart-text]')) selector.querySelector('[data-add-to-cart-text]').innerText = 'Add to Cart';
        if(selector.querySelector('.btn__text')) selector.querySelector('.btn__text').innerText = 'Add to Cart';
        selector.removeAttribute('data-view-cart');
        selector.classList.remove('btn--view');
      });

      // priceChange
   setTimeout(function() {
    var getUrl = document.querySelector('.hidden_master').dataset.url;
    var sectionId = document.querySelector('.hidden_master').dataset.section;
    var finalUrl = window.location.href + '&section_id=' + sectionId;
    
    fetch(finalUrl)
        .then((response) => response.text())
        .then((responseText) => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(responseText, 'text/html');
            
            // Find all the '.varPrice' elements in the fetched HTML response
            var productPrices = $(doc).find('.varPrice');
            
            // Find all the '.varPrice' elements in the current document
            var currentVarPrices = document.querySelectorAll('.varPrice');
            
            // Check if there are corresponding elements to replace HTML with
            if (productPrices.length > 0 && currentVarPrices.length > 0) {
                // Loop through both productPrices and currentVarPrices
                productPrices.each(function(index, element) {
                    if (currentVarPrices[index]) {
                        var productPriceHTML = $(element).html();
                        // Replace the HTML content of the corresponding current varPrice element
                        currentVarPrices[index].innerHTML = productPriceHTML;
                    }
                });
            }



           const MetaDescription = document.querySelector('#varinatMetaDescription');
            const productHandle = MetaDescription.getAttribute('product-handle')
          //  console.log(productHandle,"--->>>productHandle")
            if (productHandle === 'targeted-treatment-series') {

              var varSummary = $(doc).find('.varSummary');
              var currentvarSummary = document.querySelectorAll('.varSummary');

              if (varSummary.length > 0 && currentvarSummary.length > 0) {
                  varSummary.each(function(index, element) {
                      if (currentvarSummary[index]) {
                          var productSummeryHTML = $(element).html();
                          currentvarSummary[index].innerHTML = productSummeryHTML;
                      }
                  });
              }

              var varDescription = $(doc).find('.varDesc');
              var currentvarDescription = document.querySelectorAll('.varDesc');

              if (varDescription.length > 0 && currentvarDescription.length > 0) {
                  varDescription.each(function(index, element) {
                      if (currentvarDescription[index]) {
                          var productDescriptionHTML = $(element).html();
                          currentvarDescription[index].innerHTML = productDescriptionHTML;
                      }
                  });
              }

            }

        })
        .catch((error) => console.error('Error fetching data:', error));
      }, 1000);



    }
  });

  const getCartCount = () => {
    fetch('/cart.js')
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(cart => {
        // console.log('cart', cart);
        document.querySelectorAll('.cart-count').forEach(item=>{
          if(cart.item_count == 0) {
            item.innerText = '';
          } else {
            item.innerText = cart.item_count;
          }
        });
    })
    .catch(error => {
        console.error('There was a problem with the fetch operation:', error);
    });
  }

  document.addEventListener('theme:cart:update', (event) => {
    getCartCount();
  });

  document.addEventListener('theme:cart:added', (event) => {
    getCartCount();
  });
  
  document.addEventListener('theme:cart:loaded', (event) => {
    setTimeout(function() {
      getCartCount();
    }, 500);
  });

  document.querySelectorAll('[data-item-remove]')?.forEach(btn => {
    btn.addEventListener('click', (event) => {
      setTimeout(function() {
        getCartCount();
      }, 500);
    });
  });
  
  document.addEventListener('theme:cart:add', (event) => {
    if (document.body.hasAttribute('data-mws-apo-generated')) {
      return;
  }
    let selector = event.detail.selector;
    selector = selector.closest('button') ? selector.closest('button'): selector;
    selector.classList.add('btn--view');
    document.addEventListener('theme:cart:added', (event) => {
      selector.setAttribute('data-view-cart', '');
      
      selector.setAttribute('type', 'button');
      if(selector.querySelector('[data-add-to-cart-text]')) selector.querySelector('[data-add-to-cart-text]').innerText = 'View In Cart';
      if(selector.querySelector('.btn__text')) selector.querySelector('.btn__text').innerText = 'View In Cart';
      selector.removeAttribute('data-add-to-cart');      

      // Attach the click event listener after setting the attributes
      selector.addEventListener('click', (event) => {
          document.querySelector('.cart__toggle').click();
      });
    });

    // MARIUS CODE:
    // const variantId = document.querySelector('[name="id"]').value;
    // const quantity = document.querySelector('[name="quantity"]')?.value || 1;
    // addToCartWithProvider(variantId, quantity)
    //   .then(data => {
    //     // Your existing success logic (show cart drawer, update cart count, etc.)
    //     //console.log('Added to cart:', data);
    //     // Example: update cart drawer, show notification, etc.
    //   })
    //   .catch(error => {
    //     //console.error('Error:', error);
    //   });
    // });

  });
  
  jQuery(document).on('click', '.cart__item__remove', function() {
    // Get the variant ID from the clicked item's data-id attribute
    let variantID = jQuery(this).data('id').split(':')[0];
    console.log('Variant ID:', variantID);
  
    // Cache selectors to optimize performance
    const $productSubmitButtons = jQuery('.product__submit__buttons');
    const $quickBuyButtons = jQuery('.product-grid-item__quick-buy .btn--view');
  
    if (variantID == currentVariant) {
      setTimeout(function() {
        // Update buttons in the product submit section
        $productSubmitButtons.find('button').removeClass('btn--view');
        $productSubmitButtons.find('[data-add-to-cart-text]').html('Add to cart');
      }, 1000);
    }
  
    setTimeout(function() {
      // Update buttons in the product grid section
      $quickBuyButtons.find('.btn__text').html('Add to cart');
      $quickBuyButtons.removeClass('btn--view');
    }, 1000);
  });
  
  // Prevent default action on quick-buy buttons when clicked
  jQuery(document).on('click', '.product-grid-item__quick-buy .btn--view', function(evt) {
    evt.preventDefault();
  });

                             

  // document.querySelector('.cart__toggle').click();


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


// document.addEventListener('DOMContentLoaded', () => {
//   const containerSelector = '.product-single__media';

//   // Event delegation for play/pause
//   document.body.addEventListener('click', (e) => {
//     const playBtn = e.target.closest('.icon-play');
//     const pauseBtn = e.target.closest('.icon-pause');

//     if (playBtn) {
//       const container = playBtn.closest(containerSelector);
//       const video = container?.querySelector('video');
//       video?.play();
//       playBtn.style.display = 'none';
//       if(container && container.querySelector('.icon-pause')) {
//         container.querySelector('.icon-pause').style.display = 'block';
//       }
//     }

//     if (pauseBtn) {
//       const container = pauseBtn.closest(containerSelector);
//       const video = container?.querySelector('video');
//       video?.pause();
//       pauseBtn.style.display = 'none';
//       if(container && container.querySelector('.icon-play')) {
//         container.querySelector('.icon-play').style.display = 'block';
//       }
//     }
//   });

//   // Video thumbnail click
//   document.querySelectorAll('.product-single__thumbnail').forEach(thumb => {
//     thumb.addEventListener('click', () => {
//       if (!thumb.querySelector('.icon-media-video')) return;
      
//       const dataId = thumb.dataset.id;
//       const grid = document.querySelector(`.product-single__media-slide[data-id="${dataId}"]`);
//       if (grid && grid.querySelector('.icon-pause') && grid.querySelector('.icon-play')) {
//         grid.querySelector('.icon-pause').style.display = 'block';
//         grid.querySelector('.icon-play').style.display = 'none';
//       }
//     });
//   });

//   // Autoplay first video
//   const firstThumb = document.querySelector('.product-single__thumbnail');
//   if (firstThumb?.querySelector('.icon-media-video')) {
//     const dataId = firstThumb.dataset.id;
//     const grid = document.querySelector(`.product-single__media-slide[data-id="${dataId}"]`);
//     if (grid && !grid.querySelector('video')) {
//       const template = grid.querySelector('template');
//       const videoEl = template.content.querySelector('video').cloneNode(true);
//       template.parentNode.insertBefore(videoEl, template);
//       const video = grid.querySelector('video');
//       if (video) {
//         video.muted = true;
//         video.play().then(() => {
//           video.closest(containerSelector)?.setAttribute('loaded', 'true');
//           video.loop = true;
//           // video.muted = false;
//         }).catch(err => console.log('Autoplay blocked', err));
//       }
//       if(grid.querySelector('.icon-play') && grid.querySelector('.icon-pause')) {
//         grid.querySelector('.icon-pause').style.display = 'block';
//         grid.querySelector('.icon-play').style.display = 'none';
//       }
//     }
//   }
// });


document.addEventListener('DOMContentLoaded', () => {
  const containerSelector = '.product-single__media';

  // 🔸 Global click listener for mute/unmute toggle
  document.body.addEventListener('click', (e) => {
    const icon = e.target.closest('.icon-mute, .icon-unmute');
    if (!icon) return;

    const container = icon.closest(containerSelector);
    const video = container?.querySelector('video');
    if (!video) return;

    // Toggle logic
    const isMuted = video.muted;

    if (isMuted) {
      // 👉 If currently muted → unmute now
      video.muted = false;
      video.volume = 1;
      container.querySelector('.icon-mute').style.display = 'flex';
      container.querySelector('.icon-unmute').style.display = 'none';
    } else {
      // 👉 If currently unmuted → mute now
      video.muted = true;
      video.volume = 0;
      container.querySelector('.icon-mute').style.display = 'none';
      container.querySelector('.icon-unmute').style.display = 'flex';
    }
  });

  // 🔸 When thumbnail clicked — load video muted
  document.querySelectorAll('.product-single__thumbnail').forEach(thumb => {
    thumb.addEventListener('click', () => {
      if (!thumb.querySelector('.icon-media-video')) return;

      const dataId = thumb.dataset.id;
      const grid = document.querySelector(`.product-single__media-slide[data-id="${dataId}"]`);
      if (!grid) return;

      // Insert video from template if not already present
      if (!grid.querySelector('video')) {
        const template = grid.querySelector('template');
        if (template) {
          const videoEl = template.content.querySelector('video').cloneNode(true);
          template.parentNode.insertBefore(videoEl, template);
        }
      }

      const video = grid.querySelector('video');
      if (video) {
        video.muted = true;
        video.loop = true;
        video.play().catch(err => console.log('Autoplay blocked:', err));
      }

      // Show unmute icon (since currently muted)
      const muteBtn = grid.querySelector('.icon-mute');
      const unmuteBtn = grid.querySelector('.icon-unmute');
      if (muteBtn && unmuteBtn) {
        muteBtn.style.display = 'none';
        unmuteBtn.style.display = 'flex';
      }
    });
  });

  // 🔸 Autoplay first video muted
  const firstThumb = document.querySelector('.product-single__thumbnail');
  if (firstThumb?.querySelector('.icon-media-video')) {
    const dataId = firstThumb.dataset.id;
    const grid = document.querySelector(`.product-single__media-slide[data-id="${dataId}"]`);
    if (grid) {
      if (!grid.querySelector('video')) {
        const template = grid.querySelector('template');
        if (template) {
          const videoEl = template.content.querySelector('video').cloneNode(true);
          template.parentNode.insertBefore(videoEl, template);
        }
      }

      const video = grid.querySelector('video');
      if (video) {
        video.muted = true;
        video.loop = true;
        video.play().catch(err => console.log('Autoplay blocked:', err));
      }

      // Show unmute icon initially (since muted)
      const muteBtn = grid.querySelector('.icon-mute');
      const unmuteBtn = grid.querySelector('.icon-unmute');
      if (muteBtn && unmuteBtn) {
        muteBtn.style.display = 'none';
        unmuteBtn.style.display = 'flex';
      }
    }
  }
});





// document.addEventListener("DOMContentLoaded", async function() {
//   const endpoint = "/api/2023-07/graphql.json"; // relative URL works on Shopify
//   const token = "7cd149e87a9bf78dd662efc5e7a3ab3a"; // Storefront token
//   // Get the current URL path
//   const urlPath = window.location.pathname;

//   // Extract the handle from the path
//   const handle = urlPath.split('/').pop();

//   let variants = [];
//   let hasNextPage = true;
//   let after = null;

//   while (hasNextPage) {
//     const query = `
//       query getProductVariants($handle: String!, $after: String) {
//         productByHandle(handle: $handle) {
//           id
//           title
//           variants(first: 100, after: $after) {
//             edges {
//               cursor
//               node {
//                 id
//                 title
//                 price { amount currencyCode }
//                 availableForSale
//                 sku
//               }
//             }
//             pageInfo { hasNextPage }
//           }
//         }
//       }
//     `;

//     const response = await fetch(endpoint, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         "X-Shopify-Storefront-Access-Token": token,
//       },
//       body: JSON.stringify({ query, variables: { handle, after } }),
//     });

//     const result = await response.json();
//     const product = result.data.productByHandle;

//     if (!product) {
//       console.error(`Product not found for handle: "${handle}"`);
//       return;
//     }

//     const edges = product.variants.edges;
//     variants.push(...edges.map(edge => edge.node));

//     hasNextPage = product.variants.pageInfo.hasNextPage;
//     after = edges.length > 0 ? edges[edges.length - 1].cursor : null;
//   }

//   console.log("Total variants fetched:", variants.length);
//   console.log(variants);
// });

// Fix 5 — ARIA Hidden Focusable Elements
// Carousel clone slides mein aria-hidden parent ke andar focusable elements ko tabindex=-1 karo
function fixAriaHiddenFocusables() {
  // Sabhi aria-hidden=true elements find karo
  document.querySelectorAll('[aria-hidden="true"]').forEach(function(hiddenEl) {
    // Andar ke saare focusable elements ko tabindex=-1 karo
    hiddenEl.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function(focusable) {
      focusable.setAttribute('tabindex', '-1');
    });
  });
}

// Page load pe run karo
document.addEventListener('DOMContentLoaded', function() {
  fixAriaHiddenFocusables();
});

// MutationObserver — jab bhi carousel slide change ho aur aria-hidden update ho
var ariaObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
      fixAriaHiddenFocusables();
    }
  });
});

// Testimonials section observe karo
document.querySelectorAll('.testimonials__slider, .splide__list, .swiper-wrapper').forEach(function(slider) {
  ariaObserver.observe(slider, {
    attributes: true,
    subtree: true,
    attributeFilter: ['aria-hidden']
  });
});


// Upgrade aria-hidden carousel slides to use inert attribute
// inert = sabhi children automatically non-focusable + screen reader hidden
function upgradeToInert() {
  document.querySelectorAll(
    '.testimonial__item[aria-hidden="true"], .quoteWrap[aria-hidden="true"], .product-grid-item[aria-hidden="true"], .stImgWrap[aria-hidden="true"]'
  ).forEach(function(el) {
    el.setAttribute('inert', '');
  });
}

document.addEventListener('DOMContentLoaded', upgradeToInert);

var inertObserver = new MutationObserver(function() {
  upgradeToInert();
});

document.querySelectorAll('.testimonials__slider, .splide__list').forEach(function(slider) {
  inertObserver.observe(slider, {
    attributes: true,
    subtree: true,
    attributeFilter: ['aria-hidden']
  });
});